import { useQuery } from "@apollo/client";
import { gql } from "@src/__generated__";
import { useNavigate } from "react-router-dom";

const GET_HR_SYNC_STEP = gql(`
  query GetHrSyncStep {
    applicationConfiguration {
      hrSyncStep
    }
  }
`);

// pollInterval of 0 = no polling
export const useHrSyncStep = () => {
  const { data, loading, startPolling, stopPolling, refetch } =
    useQuery(GET_HR_SYNC_STEP);

  const navigate = useNavigate();

  return {
    step: data?.applicationConfiguration.hrSyncStep,
    loading,
    navigate,
    refetch,
    startPolling,
    stopPolling,
  };
};
